import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import Apparel21CredentialsStore from '../../../stores/credentials/apparel21-credentials-store';

interface IIntegrationProps {
    credentialsStore: Apparel21CredentialsStore,
    vGroup: IValidationGroup,
}

const Apparel21Credentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine
                label='AP21 username'
                note='Your AP21 username'
                required
                key='username'
            >
                <Input
                    value={credentialsStore.username}
                    placeholder=''
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='AP21 password'
                note='Your AP21 password'
                required
                key='password'
            >
                <Input
                    value={credentialsStore.password}
                    placeholder=''
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Country code'
                required
                key='country_code'
            >
                <Input
                    value={credentialsStore.countryCode}
                    placeholder=''
                    onChange={v => credentialsStore.countryCode = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Base URL'
                required
                key='base_url'
            >
                <Input
                    value={credentialsStore.baseUrl}
                    placeholder=''
                    onChange={v => credentialsStore.baseUrl = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default Apparel21Credentials;
